import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import CreateTeamForm from "../CreateTeamForm";
import TeamMembers from "../TeamMembers";
import { getTeams } from "../../../services/olympiad/teamService";
import { UserContext } from "../../../utils/contexts/UserContext";

export default function MyTeam() {
  const [t] = useTranslation();
  const { user } = useContext(UserContext);
  const [team, setTeam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTeam = () => {
      if (!user?.uuid) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      getTeams({})
        .then((res) => {
          setTeam(res.results[0]);
        })
        .catch((err) => {
          console.error("Error fetching team:", err);
          setError(err.response?.data?.detail || t("team.error_fetching_team"));
        })
        .finally(() => {
          setLoading(false);
        });
    };

    fetchTeam();
  }, [user, t]);

  const handleTeamCreated = (teamData) => {
    setTeam(teamData);
  };

  if (loading) {
    return (
      <div className="min-h-screen  py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex justify-center items-center h-64">
            <p className="text-gray-600">{t("team.loading")}</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen  py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <p className="text-red-800">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen  py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">{t("team.my_team")}</h1>

        {!team ? (
          <CreateTeamForm onTeamCreated={handleTeamCreated} />
        ) : (
          <TeamMembers team={team} setTeam={setTeam} />
        )}
      </div>
    </div>
  );
}
